<div *ngIf="section == 'intro'">
  <h1><code>ViewContainerRef</code></h1>
</div>


<div *ngIf="section == 'direct'">
  <h2>direct</h2>
  <p>
    <code>app-circle</code> is shown directly. First the default black, then red and orange.
  </p>
</div>


<div *ngIf="section == 'container'">
  <h2>container</h2>
  <p>
    The circles are added in the same sequence as above, but with index 0, and therefore from right to left.<br>
  </p>
</div>



<div *ngIf="section == 'toggle'">
  <h2>toggle</h2>
  <p>
    The tag with <code>ngComponentOutlet</code> is replaced by the content of the variable <code>shape</code>.<br>
    A click in the green square changes this variable's content between
    <code>CircleComponent</code> and <code>SquareComponent</code>.<br>
    <span class="light"><a href="/#/18">Branch 18</a> is an extension of this example.</span>
  </p>
</div>
